import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _isNumber from 'lodash/isNumber';
import _throttle from 'lodash/throttle';
import { ItemCartContext } from '../../CatalogItemCart.context';
import './QuantitySelector.css';
var defaultProps = {
  minimum: 0,
  maximum: null
};
function QuantitySelector(_ref) {
  var minimum = _ref.minimum,
    maximum = _ref.maximum;
  var _useContext = useContext(ItemCartContext),
    loading = _useContext.loading,
    quantity = _useContext.quantity,
    setQuantity = _useContext.setQuantity;
  function handleQuantityChange(e, quantityChange) {
    e.preventDefault();
    e.stopPropagation();
    setQuantity(function (prevQuantity) {
      return prevQuantity + quantityChange;
    });
  }
  return /*#__PURE__*/React.createElement(Button.Group, {
    className: "quantity-selector"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "minus",
    onClick: _throttle(function (e) {
      return handleQuantityChange(e, -1);
    }, 100),
    disabled: loading || _isNumber(minimum) && quantity === minimum
  }), /*#__PURE__*/React.createElement("div", {
    className: "quantity-display ui button disabled"
  }, quantity), /*#__PURE__*/React.createElement(Button, {
    icon: "plus",
    onClick: _throttle(function (e) {
      return handleQuantityChange(e, 1);
    }, 100),
    disabled: loading || _isNumber(maximum) && quantity === maximum
  }));
}
QuantitySelector.defaultProps = defaultProps;
export default QuantitySelector;